import useWindowDimensions from './useWindowSize';

const useIsMobile = () => {
  const { width } = useWindowDimensions();

  return width < 664;
};

export default useIsMobile;
